import { CommonModule, DatePipe } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-grid-test',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss',
})
export class FormGridTest implements OnInit {
  ngOnInit(): void {}

  public onKeyDown(keyDown: KeyboardEvent): void {
    if (keyDown.code == 'Space') keyDown.stopPropagation();
  }
}
